module.exports = __webpack_public_path__ + "static/scale-model-of-splash-into-the-edwards-aquifer-in-austin-texas-1f529d55e7624d7d2f5eff468774f896.png";